import React from 'react';
import PropTypes from 'prop-types';

import { AuthManager } from 'inside-out/managers/authManager';
import { idToLink } from 'inside-out/managers/navManager';

import { Link } from 'inside-out/components/shared/link';

import { Queries } from './queries';

import BookmarkIconImage from 'inside-out/images/bookmark-icon.svg';
import BookmarkHoverIconImage from 'inside-out/images/bookmark-hover-icon.svg';
import BookmarkActiveIconImage from 'inside-out/images/bookmark-active-icon.svg';
import BookmarkSelectedIconImage from 'inside-out/images/bookmark-selected-icon.svg';
import BookmarkSelectedHoverIconImage from 'inside-out/images/bookmark-selected-hover-icon.svg';

const BookmarkImage = ({ selected, width }) => (
	<img
		src={selected ? BookmarkSelectedIconImage : BookmarkIconImage}
		alt="Bookmark"
		width={width}
		style={{ backfaceVisibility: 'hidden', transform: 'perspective(1px)' }}
		onMouseOver={e =>
			(e.target.src = selected ? BookmarkSelectedHoverIconImage : BookmarkHoverIconImage)
		}
		onMouseOut={e => (e.target.src = selected ? BookmarkSelectedIconImage : BookmarkIconImage)}
		onMouseDown={e => (e.target.src = BookmarkActiveIconImage)}
		onMouseUp={e => (e.target.src = BookmarkIconImage)}
	/>
);

BookmarkImage.propTypes = {
	width: PropTypes.number.isRequired,
	selected: PropTypes.bool,
};

BookmarkImage.defaultProps = {
	selected: false,
};

export default class BookmarkIcon extends React.PureComponent {
	static defaultProps = {
		width: 16,
	};

	static propTypes = {
		bookmarkableContent: PropTypes.shape({
			id: PropTypes.string,
			to: PropTypes.string,
		}).isRequired,
		bookmarkType: PropTypes.string.isRequired,
		width: PropTypes.number,
	};

	render() {
		const { bookmarkableContent, bookmarkType, width } = this.props;

		if (!AuthManager.sharedInstance.isLoggedIn || !AuthManager.sharedInstance.userId) {
			return (
				<Link to={AuthManager.sharedInstance.getLoginAndReturnLink()}>
					<BookmarkImage width={width} />
				</Link>
			);
		}

		const contentId = bookmarkableContent.id
			? idToLink(bookmarkableContent.id)
			: bookmarkableContent.to;

		return (
			<Queries
				bookmarkableContent={bookmarkableContent}
				bookmarkType={bookmarkType}
				contentId={contentId}
			>
				{({ loading, data, createBookmark, removeBookmark }) => {
					if (loading || !data || !data.user) {
						return (
							<span>
								<BookmarkImage width={width} />
							</span>
						);
					}

					if (data.user.bookmarks.length) {
						return (
							<button
								onClick={removeBookmark}
								style={{
									border: 'none',
									padding: '0',
								}}
							>
								<BookmarkImage width={width} selected />
							</button>
						);
					} else {
						return (
							<button
								onClick={createBookmark}
								style={{
									border: 'none',
									padding: '0',
								}}
							>
								<BookmarkImage width={width} />
							</button>
						);
					}
				}}
			</Queries>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/shared/icons/bookmarkIcon/component.js